module.exports = __webpack_public_path__ + "static/media/openbook.ddd439b6.svg";